import { ILimit } from "../../types";

export interface ISegment {
  start: number;
  end: number;
  color: string;
}



export enum SeverityEnum {
  none,
  info,
  warning,
  error
}

export interface IPoint {
  x: number | string;
  y: number;
  status?: "OK" | "BAD"  | "UP"  | "DOWN"  | "NONE";
  color?: string | null;
  severity?: SeverityEnum;
  limits?: ILimit[];
}

export interface IRange {
  minimum: number;
  maximum: number;
  color: string;
}

export interface ISeries {
  hash?: string;
  name: string;
  value: number | number[] | IPoint[];
  color: string;
  unit?: string;
  hidden?: boolean;
  converter?: (n: number | { value: number, } | string | IPoint) => number;
}

export interface ISeriesWithAxes extends ISeries {
  xAxisName: string;
  yAxisName: string;
  type?: "line" | "area";
  ranges?: IRange[];
  limits?: ILimit[];
}

export interface IAxis {
  name: string;
  ticksAngle?: number;
  hidden?: boolean;
  hiddenTickText?: boolean;
  fontSize?: string | number;
  formatTick?: (n: number | { value: number, } | string | IPoint, index: number, length?: number) => string;
}

export interface IAxisLinear extends IAxis {
  minimum: number;
  maximum: number;
  ticksCount: number;
  adjustAxis?: boolean;
}

export interface IAxisBand  extends IAxis {
  categories: string[];
}

export type AxisTypes = IAxisLinear | IAxisBand;

export type TickTypes = number[] | string[];

export interface IGaugeConfig {
  width?: number;
  height?: number;
  segments: ISegment[];
  minimum: number;
  maximum: number;
  start: number;
  length: number;
  color?: string;
  format?: (n: number) => string;
}

export interface IPieConfig {
  width?: number;
  height?: number;
  series: ISeries[];
  seriesDetail?: ISeries[];
  title?: string;
  radius?: number;
  padAngle: number;
  innerRadius: number;
  seriesRadius: number;
  valueRadius?: number;
  maximum?: number;
  emptyColor?: string;
  showLegend?: boolean;
  showPercent?: boolean;
  showTotal?: boolean;
  showValue?: boolean;
  scale?: number;
  sort?: "NAME" | "VALUE" | "NONE";
  formatValue?: (n: number, index: number) => string;
}

export interface IBarChartConfig {
  width?: number;
  height?: number;
  series: ISeriesWithAxes[];
  xAxis: IAxisBand;
  yAxis: IAxisLinear[];
  title?: string;
  multiple?: boolean;
  showLegend?: boolean;
  showValue?: boolean;
  accumulate?: boolean;
}

export interface ILineChartConfig {
  width?: number;
  height?: number;
  series: ISeriesWithAxes[];
  title?: string;
  xAxis: AxisTypes;
  yAxis: AxisTypes[];
  showLegend?: boolean;
  pointStyle?: {
    radius: number;
  };
}

export interface IRadarChartConfig {
  width?: number;
  height?: number;
  series: ISeriesWithAxes[];
  title?: string;
  xAxis: AxisTypes;
  yAxis: AxisTypes;
  showLegend?: boolean;
}

export interface IStackerAreaChartConfig {
  width?: number;
  height?: number;
  series: ISeries[];
  xAxis: AxisTypes;
  yAxis: IAxis;
  title?: string;
  showLegend?: boolean;
}

export interface IStackedBarChartConfig {
  width?: number;
  height?: number;
  series: ISeries[];
  xAxis: IAxisBand;
  yAxis: IAxis;
  title?: string;
  showLegend?: boolean;
  showValue?: boolean;
  accumulate?: boolean;
}

export interface ITreeMapNode  {
  name: string;
  value: number;
  color?: string;
  children?: ITreeMapNode[];
}

export interface ITreeMapChartConfig {
  width?: number;
  height?: number;
  root: ITreeMapNode;
  series: ISeries[];
  title?: string;
  showLegend?: boolean;
  showValue?: boolean;
}

export interface IHeatMapChartConfig {
  width?: number;
  height?: number;
  xAxis: IAxisBand;
  series: ISeries[];
  title?: string;
  showLegend?: boolean;
  showValue?: boolean;
}

export interface IScaleViewPort {
  offset: number;
  scale: number;
  action: "SCALE" | "OFFSET" | "RESET";
}